/**
 * Mission Briefing Slice (GW-7870)
 *
 * Holds the in-progress MissionBriefing draft that flows from the
 * search-next mission-lead launch into /marketplace/missions/create
 * (CreateMissionPage). Persisted via store.ts partialize so the draft
 * survives a page refresh mid-review, mirroring serviceWizardDraft.
 */

import type { MissionBriefing } from '@gw/ui/types';
import type { StateCreator } from 'zustand';

export interface MissionBriefingSlice {
  missionBriefing: MissionBriefing | null;
  setMissionBriefing: (briefing: MissionBriefing) => void;
  clearMissionBriefing: () => void;
}

const initial: Pick<MissionBriefingSlice, 'missionBriefing'> = {
  missionBriefing: null,
};

export const createMissionBriefingSlice: StateCreator<
  MissionBriefingSlice,
  [],
  [],
  MissionBriefingSlice
> = (set) => ({
  ...initial,
  setMissionBriefing: (briefing) => set({ missionBriefing: briefing }),
  clearMissionBriefing: () => set({ ...initial }),
});
